import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
//

export default function ActionsMenu({
  row,
  onEdit,
  onDelete,
  onAddBookCopy,
  onViewBookCopies,
  onlyCopyActions,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <Button
        variant="contained"
        size="medium"
        startIcon={<MoreVertIcon />}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#115293" },
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Actions
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onEdit(row);
          }}
          sx={{ minWidth: 50, color: "blue", "&:hover": { backgroundColor: "rgba(0,0,255,0.1)" } }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          {onlyCopyActions ? "Edit Book Copy" : "Edit Book"}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onDelete(row);
          }}
          sx={{ minWidth: 100, color: "red", "&:hover": { backgroundColor: "rgba(255,0,0,0.1)" } }}
        >
          <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
          {onlyCopyActions ? "Delete Book Copy" : "Delete Book"}
        </MenuItem>
        {!onlyCopyActions && (
          <>
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                if (typeof onAddBookCopy === "function") onAddBookCopy(row);
              }}
              sx={{
                minWidth: 120,
                color: "#1976d2",
                "&:hover": { backgroundColor: "rgba(25,118,210,0.1)" },
              }}
            >
              <LibraryAddIcon fontSize="small" style={{ marginRight: 8 }} />
              Add Book Copy
            </MenuItem>

            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                if (typeof onViewBookCopies === "function") onViewBookCopies(row);
              }}
              sx={{
                minWidth: 140,
                color: "#1976d2",
                "&:hover": { backgroundColor: "rgba(25,118,210,0.1)" },
              }}
            >
              <CollectionsBookmarkIcon fontSize="small" style={{ marginRight: 8 }} />
              View Book Copies
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}

ActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAddBookCopy: PropTypes.func,
  onViewBookCopies: PropTypes.func,
  onlyCopyActions: PropTypes.bool,
};
